import { createTheme } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface Palette {
    custom: {
      red: string;
      redDark: string;
      green: string;
      greenDark: string;
      orange: string;
      orangeDark: string;
      navy: string;
      navyDark: string;
      grey: string;
      greyDark: string;
      dark: string;
      purple: string;
      purpleDark: string;
    }
  }
  interface PaletteOptions {
    custom?: {
      red: string;
      redDark: string;
      green: string;
      greenDark: string;
      orange: string;
      orangeDark: string;
      navy: string;
      navyDark: string;
      grey: string;
      greyDark: string;
      dark: string;
      purple: string;
      purpleDark: string;
    }
  }
}

const theme = createTheme({
  palette: {
    primary: {
      main: '#114776',
      light: '#155E93',
      dark: '#0E365B',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#0891b2',
      light: '#06b6d4',
      dark: '#0e7490',
      contrastText: '#ffffff',
    },
    success: {
      main: '#16a34a',
      light: '#22c55e',
      dark: '#15803d',
    },
    info: {
      main: '#0284c7',
      light: '#0ea5e9',
      dark: '#0369a1',
    },
    warning: {
      main: '#d97706',
      light: '#f59e0b',
      dark: '#b45309',
    },
    error: {
      main: '#dc2626',
      light: '#ef4444',
      dark: '#b91c1c',
    },
    background: {
      default: '#f8fafc',
      paper: '#ffffff',
    },
    custom: {
      red: '#962A2A',
      redDark: '#7C2222',
      green: '#169B4E',
      greenDark: '#138040',
      orange: '#F59700',
      orangeDark: '#D38100',
      navy: '#506BCC',
      navyDark: '#4056A0',
      grey: '#A3A3A3',
      greyDark: '#808080',
      purple: '#506BCC',
      purpleDark: '#4056A0',
      dark: '#424669',
    },
    text: {
      primary: '#1e293b',
      secondary: '#64748b',
    },
  },
  typography: {
    fontFamily: [
      'Kanit',
      'Roboto',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
    h4: {
      fontWeight: 500,
    },
    h5: {
      fontWeight: 500,
    },
    h6: {
      fontWeight: 500,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 4,
          height: 40,
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        size: 'small',
      },
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 4,
          },
        },
      },
    },
    MuiSelect: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiFormControl: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiAutocomplete: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiPaper: {
      defaultProps: {
        elevation: 0,
      },
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
    MuiPagination: {
      styleOverrides: {
        root: {
          '& .MuiPaginationItem-root': {
            borderRadius: 4,
          },
        },
      },
    },

    MuiTableHead: {
      defaultProps: {
        sx: {
          bgcolor: '#E7F3FD',
        },
      },
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          maxWidth: "100%",
          overflowX: "auto",
          "& .MuiTableCell-root": {
            py: 1.5,
            px: 2,
            fontSize: { xs: "0.75rem", sm: "0.875rem" },
          },
          position: 'relative',
          overflow: 'auto hidden',
          '& thead': {
            position: 'sticky',
            top: 0,
            zIndex: 1,
            bgcolor: '#E7F3FD',
            '& th': {
              bgcolor: '#E7F3FD'
            }
          },
          '&::-webkit-scrollbar': {
            height: 8
          },
          '&::-webkit-scrollbar-track': {
            backgroundColor: '#f1f1f1'
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#888',
            borderRadius: 4
          },
          '&::-webkit-scrollbar-thumb:hover': {
            backgroundColor: '#555'
          }
        }
      }
    },
  },
});

export default theme; 